module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_18.f2ba43ec.pdf";